/**
 * Reads a required `NEXT_PUBLIC_*` value, failing loudly when it is absent.
 *
 * These used to be interpolated (`${process.env.X}`), which turned a missing
 * var into the literal string `'undefined'` and produced URLs like
 * `undefined/v1/auth/token` — a silent misconfiguration that only surfaced as
 * an opaque network error deep inside the SYNC flow.
 */
function requiredEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }

  return value;
}

/**
 * Values are exposed as getters so the check runs when a value is actually
 * used, not at import time: importing this module must never be able to break
 * an unrelated page (or a test that does not exercise the SYNC flow).
 */
export const authConfig = {
  get baseUrl(): string {
    return requiredEnv(
      'NEXT_PUBLIC_ONBOARDING_API_URL',
      process.env.NEXT_PUBLIC_ONBOARDING_API_URL,
    );
  },
  get clientId(): string {
    return requiredEnv(
      'NEXT_PUBLIC_ONBOARDING_CLIENT_ID',
      process.env.NEXT_PUBLIC_ONBOARDING_CLIENT_ID,
    );
  },
  get startUpUrl(): string {
    return requiredEnv(
      'NEXT_PUBLIC_ONBOARDING_REDIRECT_URL',
      process.env.NEXT_PUBLIC_ONBOARDING_REDIRECT_URL,
    );
  },
  get redirectUri(): string {
    const domainUrl = requiredEnv(
      'NEXT_PUBLIC_DOMAIN_URL',
      process.env.NEXT_PUBLIC_DOMAIN_URL,
    );

    return `${domainUrl}/auth/callback`;
  },
  apiVersion: 'v1',
  scope: 'client',
};
